<div class="hig-panel">
    <h3 class="hig-panel__title"><i class="bi bi-chat me-2"></i>How it's going</h3>

    <div *ngIf="isFullyUnanswered; else answered" class="hig-empty">
        <cdss-weekly-state-label state="noCheckIn" text="Not answered this week"></cdss-weekly-state-label>
    </div>

    <ng-template #answered>
        <ul class="hig-list">
            <li class="hig-row">
                <span class="hig-row__label"><i class="bi bi-emoji-smile hig-row__icon hig-row__icon--yellow"></i>Carer wellbeing</span>
                <span class="hig-row__value">
                    <ng-container *ngIf="progressFeelingLabel; else notRatedProgress">{{ progressFeelingLabel }}</ng-container>
                    <ng-template #notRatedProgress>
                        <cdss-weekly-state-label state="notRated"></cdss-weekly-state-label>
                    </ng-template>
                </span>
            </li>
            <li class="hig-row">
                <span class="hig-row__label"><i class="bi bi-emoji-smile hig-row__icon hig-row__icon--green"></i>Univa helpful</span>
                <span class="hig-row__value">
                    <ng-container *ngIf="univaHelpfulnessLabel; else notRatedHelpfulness">{{ univaHelpfulnessLabel }}</ng-container>
                    <ng-template #notRatedHelpfulness>
                        <cdss-weekly-state-label state="notRated"></cdss-weekly-state-label>
                    </ng-template>
                </span>
            </li>
        </ul>
    </ng-template>
</div>
